import { Notification } from '../../notifications/core/notification/implementation';
export class AbortNotification extends Notification {
    constructor(reason) {
        super('abort', reason);
    }
}
//# sourceMappingURL=abort-notification.js.map